import FeatureGroups from './FeatureGroups'

export default FeatureGroups
